/**
 * Recently Viewed Slider Logic
 * Assets/recently-viewed-slider.js
 */
(function() {
  const initRecentSlider = (section) => {
    const swiperContainer = section.querySelector('.swiper-container');
    if (!swiperContainer || swiperContainer.classList.contains('swiper-initialized')) return;

    // The products are injected into #RecentlyViewed-{{section.id}}
    // Swiper needs to know that this container has changed
    new Swiper(swiperContainer, {
      direction: 'horizontal',
      slidesPerView: 1.5,
      spaceBetween: 15,
      freeMode: true,
      grabCursor: true,
      scrollbar: {
        el: swiperContainer.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      navigation: {
        nextEl: swiperContainer.querySelector(".swiper-button-next"),
        prevEl: swiperContainer.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        580: { slidesPerView: 2, slidesPerGroup: 2 },
        959: { slidesPerView: 3, slidesPerGroup: 3 },
        1050: { slidesPerView: 4, slidesPerGroup: 4 }
      },
      on: {
        init: function() {
          swiperContainer.classList.add('swiper-initialized');
        }
      }
    });
  };

  document.addEventListener('recently-viewed:loaded', function(e) {
    if (e.detail && e.detail.section) {
      initRecentSlider(e.detail.section);
    }
  });
})();